module.exports = __webpack_public_path__ + "static/media/csharp.eaa9632e.svg";